module.exports = __webpack_public_path__ + "static/img/saimenInstallForMac_pic14.7eba77d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForMac/saimenInstallForMac_pic14.png
// module id = 565
// module chunks = 1